/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationDurations200ResponseOneOf
 */
export interface GetReservationDurations200ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetReservationDurations200ResponseOneOf
     */
    type: GetReservationDurations200ResponseOneOfTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReservationDurations200ResponseOneOf
     */
    value: number;
}


/**
 * @export
 */
export const GetReservationDurations200ResponseOneOfTypeEnum = {
    All: 'ALL'
} as const;
export type GetReservationDurations200ResponseOneOfTypeEnum = typeof GetReservationDurations200ResponseOneOfTypeEnum[keyof typeof GetReservationDurations200ResponseOneOfTypeEnum];


/**
 * Check if a given object implements the GetReservationDurations200ResponseOneOf interface.
 */
export function instanceOfGetReservationDurations200ResponseOneOf(value: object): value is GetReservationDurations200ResponseOneOf {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetReservationDurations200ResponseOneOfFromJSON(json: any): GetReservationDurations200ResponseOneOf {
    return GetReservationDurations200ResponseOneOfFromJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationDurations200ResponseOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
    };
}

export function GetReservationDurations200ResponseOneOfToJSON(json: any): GetReservationDurations200ResponseOneOf {
    return GetReservationDurations200ResponseOneOfToJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOfToJSONTyped(value?: GetReservationDurations200ResponseOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

